import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  trigger: {
    id: 'bitkit.navigation.helpMenu.trigger',
    description: 'Label for help menu trigger',
    defaultMessage: 'Help',
  },
  tooltip: {
    id: 'bitkit.navigation.helpMenu.tooltip',
    description: 'Tooltip for help menu trigger',
    defaultMessage: 'Help',
  },
  helpHeading: {
    id: 'bitkit.navigation.helpMenu.helpHeading',
    description: 'Heading for help section in help menu',
    defaultMessage: 'Help',
  },
  informationHeading: {
    id: 'bitkit.navigation.helpMenu.informationHeading',
    description: 'Heading for information section in help menu',
    defaultMessage: 'Information',
  },
  legalHeading: {
    id: 'bitkit.navigation.helpMenu.legalHeading',
    description: 'Heading for legal section in help menu',
    defaultMessage: 'Legal',
  },
  documentationLink: {
    id: 'bitkit.navigation.helpMenu.documentationLink',
    description: 'Text for link to Bitbucket documentation',
    defaultMessage: 'Documentation',
  },
  learnGitLink: {
    id: 'bitkit.navigation.helpMenu.learnGitLink',
    description: 'Text for link to learn about Git',
    defaultMessage: 'Learn Git',
  },
  keyboardShortcutsButton: {
    id: 'bitkit.navigation.helpMenu.keyboardShortcutsButton',
    description: 'Text for button to open keyboard shortcuts dialog',
    defaultMessage: 'Keyboard shortcuts',
  },
  tutorialsLink: {
    id: 'bitkit.navigation.helpMenu.tutorialsLink',
    description: 'Text for link to Bitbucket tutorials',
    defaultMessage: 'Bitbucket tutorials',
  },
  apiLink: {
    id: 'bitkit.navigation.helpMenu.apiLink',
    description: 'Text for link to API documentation',
    defaultMessage: 'API',
  },
  supportLink: {
    id: 'bitkit.navigation.helpMenu.supportLink',
    description: 'Text for link to Bitbucket support page',
    defaultMessage: 'Support',
  },
  blogLink: {
    id: 'bitkit.navigation.helpMenu.blogLink',
    description: 'Text for link to Bitbucket blog',
    defaultMessage: 'Blog',
  },
  plansLink: {
    id: 'bitkit.navigation.helpMenu.plansLink',
    description: 'Text for link to Bitbucket plans and pricing page',
    defaultMessage: 'Plans & pricing',
  },
  siteStatusLink: {
    id: 'bitkit.navigation.helpMenu.siteStatusLink',
    description: 'Text for link to Bitbucket site status site',
    defaultMessage: 'Site status',
  },
  attributionsPageLink: {
    id: 'bitkit.navigation.helpMenu.attributionsPageLink',
    description: 'Text for link to Bitbucket attributions page',
    defaultMessage: 'Attributions',
  },
  supportAdminLink: {
    id: 'bitkit.navigation.helpMenu.supportAdmin',
    description: 'Text for link to Bitbucket Support admin',
    defaultMessage: 'Support admin',
  },
  internalToolsSectionTitle: {
    id: 'bitkit.navigation.helpMenu.internalToolsSectionTitle',
    description: 'Text for internal tools section',
    defaultMessage: 'Internal tools',
  },
  termsOfServiceLink: {
    id: 'bitkit.navigation.helpMenu.termsOfServiceLink',
    description: 'Text for link to Atlassian terms of service',
    defaultMessage: 'Terms of service',
  },
  noticeOfCollectionLink: {
    id: 'bitkit.navigation.helpMenu.noticeOfCollectionLink',
    description: 'Text for link to Atlassian notice of collection',
    defaultMessage: 'Notice of collection',
  },
  privacyPolicyLink: {
    id: 'bitkit.navigation.helpMenu.privacyPolicyLink',
    description: 'Text for link to Atlassian privacy policy',
    defaultMessage: 'Privacy policy',
  },
  whatsNewTitle: {
    id: 'bitkit.navigation.whatsNew',
    description:
      'Heading to display for the "Whats new" menu containing links to new blog posts',
    defaultMessage: "What's new",
  },
  learnMoreLink: {
    id: 'bitkit.navigation.learnMore',
    description: 'Text for links which take the user to the full blog post',
    defaultMessage: 'Learn more',
  },
  newLabel: {
    id: 'bitkit.navigation.newBlogLabel',
    description:
      'Text to show inside the green lozenge alongside new blog posts',
    defaultMessage: 'New',
  },
  giveFeedbackButton: {
    id: 'bitkit.navigation.helpMenu.giveFeedbackButton',
    description: 'Text for button to open feedback modal',
    defaultMessage: 'Give feedback',
  },
});
